import { InfoBox } from "@airhelp/react";
import { Info } from "@airhelp/icons";
import RichtextAdapter from "modules/storyblok/adapters/RichtextAdapter";
import type { FeeModelCardsAdapterProps } from "modules/storyblok/adapters/FeeModelCards";

const customStyles = {
  paragraph: { fontSize: "md" },
  link: { fontWeight: "normal" },
};
const shouldRenderInfoBox = (infoBoxText) => infoBoxText && !!infoBoxText?.content[0]?.content;

const FeeInfoBox = ({ infoBoxText }: Pick<FeeModelCardsAdapterProps, "infoBoxText">) =>
  shouldRenderInfoBox(infoBoxText) ? (
    <InfoBox variant="secondary" isChat icon={<Info color="primary.500" boxSize={5} verticalAlign="text-top" />}>
      <RichtextAdapter content={infoBoxText} customStyles={customStyles} />
    </InfoBox>
  ) : null;

export default FeeInfoBox;
